import { queryKeys } from '@/lib/query-keys';
import { apiClient } from '@borradh-workspace/api-client';
import type { StripeConnectStatus } from '@borradh-workspace/api-client/types';
import { stripeConnectStatusSchema } from '@borradh-workspace/contracts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getAccountStatusQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.integrations.stripeAccountStatus(),
    queryFn: () =>
      apiClient.get<StripeConnectStatus>('integrations/stripe/account-status', {
        schema: stripeConnectStatusSchema,
      }),
    staleTime: 60 * 1000,
  });

export const useGetAccountStatus = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  const query = useQuery({ ...getAccountStatusQueryOptions(), enabled });
  return {
    status: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
